import { useModals } from '@frontend/modal';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useTabFilters } from '../../../hooks/use-tab-filters';
import { useAppDispatch } from '../../../redux/store';

interface ViewProps {
    activeTab: string;
    dispatch: ReturnType<typeof useAppDispatch>;
    getListId: (tabKey: string) => string;
    navigate: ReturnType<typeof useNavigate>;
    location: ReturnType<typeof useLocation>;
    openModal: ReturnType<typeof useModals>['openModal'];
    categoryModalId: string;
}

export const useCategories = (): ViewProps => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { openModal } = useModals();
    const categoryModalId = 'category-modal';
    const [searchParams] = useSearchParams();
    const activeTab = searchParams.get('tab') || 'directory';

    const { getListId } = useTabFilters({
        pageId: 'categories',
        tabs: ['directory', 'table'],
        activeTab
    });

    return {
        activeTab,
        dispatch,
        getListId,
        navigate,
        location,
        openModal,
        categoryModalId
    };
};
